import { FC } from 'react';
import styled from 'styled-components';

import { COLORS } from '@/shared/constants/colors';
import { Icon } from '@/shared/uikit/Icon';
import { IconName } from '@/shared/uikit/Icon/types';
import { Button } from '@/shared/uikitV2/Button';

type EmptyMessage = {
  text: string;
  buttonText?: string;
  iconName: IconName;
  onClick?: () => void;
};

export const EmptyMessage: FC<EmptyMessage> = ({ text, buttonText, iconName, onClick }) => {
  return (
    <EmptyContainer>
      <TextWrapper>
        <Icon style={{ color: COLORS.systemDark100 }} name={iconName} size="s44" />
        <b>{text}</b>
      </TextWrapper>
      {onClick && buttonText && (
        <Button type="default" onClick={onClick}>
          {buttonText}
        </Button>
      )}
    </EmptyContainer>
  );
};

const EmptyContainer = styled.div`
  padding: 24px;
  border-radius: 24px;
  background: ${COLORS.white};
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 24px;
  color: ${COLORS.systemDark200};
`;

const TextWrapper = styled.div`
  display: flex;
  gap: 12px;
  align-items: center;
  flex-direction: column;
`;
